import * as types from "../../actions/types";

const initialState = {
  listOffice: [],
  total: 0,
  err: '',
  dataFilter: {},
  alert:'',
  textSearch: ''
}

export default function filterOfficeReducer(state = initialState, action) {
  switch (action.type) {
    case types.FILTER_OFFICE:
      return {
        ...state,
        listOffice: action.listOffice,
        total: action.total,
        dataFilter: action.dataFilter,
      }
    case types.FILTER_OFFICE_ERR:
      return {
        ...state,
        err: action.err
      }
    case types.ALERT_CONTENT:
      return {
        ...state,
        alert: action.alert
      }
    case types.SAVE_TEXT_OFFICE:
      return {
        ...state,
        textSearch: action.textSearch
      }
    case types.CLEAR_TEXT_OFFICE:
      return {
        ...state,
        textSearch: ''
      }
    default:
      return state
  }
}